function parseTimeToMinutes(timeStr) {
  if (!timeStr || timeStr === '--:--' || timeStr === '--:--:--') return null;
  const parts = String(timeStr).trim().split(':');
  const h = parseInt(parts[0], 10);
  const m = parseInt(parts[1], 10);
  if (Number.isNaN(h) || Number.isNaN(m)) return null;
  return (h % 24) * 60 + m;
}

function minutesTo12h(totalMinutes) {
  const h = Math.floor(totalMinutes / 60) % 24;
  const m = totalMinutes % 60;
  const period = h >= 12 ? 'PM' : 'AM';
  const hour12 = h % 12 || 12;
  return `${hour12}:${String(m).padStart(2, '0')} ${period}`;
}

/** Convert 24h time (HH:mm or HH:mm:ss) to 12h with AM/PM */
export function formatTime12h(timeStr) {
  if (!timeStr || timeStr === '--:--' || timeStr === '--:--:--') return '--:--';
  const minutes = parseTimeToMinutes(timeStr);
  if (minutes === null) return timeStr;
  return minutesTo12h(minutes);
}

/** Format attendance time — uses employee shift context for consistent AM/PM display */
export function formatAttendanceTime(timeStr, _shift, _type = 'in') {
  return formatTime12h(timeStr);
}

/** Format shift range like "21:00-06:00" → "9:00 PM - 6:00 AM" */
export function formatShiftRange12h(shift) {
  if (!shift || !String(shift).includes('-')) return shift || '—';
  const [start, end] = String(shift).split('-').map((s) => s.trim());
  return `${formatTime12h(start)} - ${formatTime12h(end)}`;
}
